var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"editName",attrs:{"contenteditable":_vm.editable,"id":"editable-name","name":"editable-name","data-testid":"editable-name"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.submitName($event)},_vm.handleKeydown],"blur":_vm.updateName}})
}
var staticRenderFns = []

export { render, staticRenderFns }